import React, { Fragment, FunctionComponent, useEffect } from 'react';
import { useStyles } from './PartnerInfo.styles';
import { useGlobalDispatch, useGlobalState } from '../../../common/context/AppContext';
import { IAppProps, REDUCER_KEY } from '../../../common/interface/IAppProvider';
import { WhitelabelPartnerLabel } from '../../../common/interface/IAppConfig';

const PartnerInfo: FunctionComponent<IAppProps> = (props): JSX.Element => {
    const baseClass = useStyles();
    const hippoTexts = props.config?.resourceBundles['onsa-erhvervsforsikring/'].read();
    const { partner } = useGlobalState();
    const header = hippoTexts['partner-info-header'];
    const body = hippoTexts['partner-info-body'];
    const discountPercentage = hippoTexts[`discount.percentage.${partner}`];
    const appDispatch = useGlobalDispatch();

    useEffect(() => {
        if (!!discountPercentage) {
            appDispatch({
                type: REDUCER_KEY.SET_PARTNER_DISCOUNT,
                payload: { percent: discountPercentage, amount: 0 },
            });
        }
    }, [appDispatch, discountPercentage]);

    return discountPercentage && partner ? (
        <Fragment>
            <div className={baseClass.parent}>
                <div className={baseClass.upperWrapper}>
                    <div className={baseClass.textbox}>
                        <div className="header">
                            {header
                                .replace('{discount}', discountPercentage)
                                .replace('{partner}', WhitelabelPartnerLabel[partner])}
                        </div>
                        <div className="text">
                            {body
                                .replace('{discount}', discountPercentage)
                                .replace('{partner}', WhitelabelPartnerLabel[partner])}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    ) : (
        <></>
    );
};

export default PartnerInfo;
